'use client';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function FooterMenu({ menu }) {
  const isMobile = useIsMobile();
  const [closeSection, setCloseSection] = useState(false);
  useEffect(() => {
    if (isMobile) {
      setCloseSection(true);
    } else {
      setCloseSection(false);
    }
  }, [isMobile]);
  return (
    <>
      <div className="flex lg:pb-6 lg:pt-0 lg:px-0 p-4 justify-between border-b border-light-gray-300 lg:border-none">
        <h3 className="spNavTitle font-bold">{menu.title}</h3>
        <div
          className="lg:hidden"
          onClick={() => setCloseSection((prev) => !prev)}
        >
          <div className={`${closeSection && 'rotate-180'}`}>
            <ArrowTop />
          </div>
        </div>
      </div>

      <ul
        className={`${
          closeSection
            ? 'mt-0 p-0 h-0 overflow-hidden '
            : 'mt-4 lg:mt-0 p-2 lg:p-0 '
        }`}
      >
        {menu.items.map((item, index) => (
          <li key={index} className="py-1.5 text-sm text-light-gray-800">
            <Link href={item.link}>{item.title}</Link>
          </li>
        ))}
      </ul>
    </>
  );
}
